<template>
  <el-card class="box-card">
    <div slot="header" class="clearfix">
      <span style="font-weight: bold;"><i class="el-icon-s-data text-blue" style="margin-right: 5px;"></i>来源统计</span>
      <i :class="isExpanded ? 'el-icon-arrow-down' : 'el-icon-arrow-right'" class="expand-icon" @click="toggleExpand"></i>
    </div>

    <div v-show="isExpanded" v-loading="loading" class="chart-container">
      <div ref="sourceChart" style="width: 100%; height: 294px;"></div>
    </div>
  </el-card>
</template>

<script>
import * as echarts from 'echarts'

export default {
  name: 'SourceStatistics',
  props: {
    targetType: {
      type: String,
      default: 'department'
    },
    url: {
      type: String,
      default: 'zhaoshang/zongjian/sourceStatistics'
    },
    employeeId: {
      type: String,
      default: ''
    }
  },
  data () {
    return {
      isExpanded: true,
      loading: false,
      chart: null,
      data: {
        trafficSources: {},
        dealSources: {}
      }
    }
  },
  created () {
    // this.fetchData()
  },
  mounted () {
    window.addEventListener('resize', this.handleResize)
  },
  beforeDestroy () {
    if (this.chart) {
      this.chart.dispose()
    }
    window.removeEventListener('resize', this.handleResize)
  },
  watch: {
    employeeId: {
      handler () {
        if (this.employeeId) {
          this.fetchData()
        }
      },
      immediate: true
    }
  },
  methods: {
    toggleExpand () {
      this.isExpanded = !this.isExpanded
      if (this.isExpanded) {
        this.$nextTick(() => {
          this.initChart()
        })
      }
    },
    async fetchData () {
      this.loading = true
      try {
        const params = {
          target: this.targetType
        }
        if (this.employeeId) {
          params.employeeId = this.employeeId
        }

        const { data: res } = await this.$http.get(this.url, {
          params
        })

        if (res.meta.status === 200) {
          this.data = res.data
          this.$nextTick(() => {
            this.initChart()
          })
        } else {
          this.$message.error(res.meta.msg)
        }
      } catch (error) {
        console.error(error)
        this.$message.error('获取来源统计失败')
      } finally {
        this.loading = false
      }
    },
    initChart () {
      if (!this.$refs.sourceChart) return

      if (this.chart) {
        this.chart.dispose()
      }

      this.chart = echarts.init(this.$refs.sourceChart)

      const allSources = new Set([
        ...Object.keys(this.data.trafficSources),
        ...Object.keys(this.data.dealSources)
      ])

      const categories = Array.from(allSources)

      const trafficData = categories.map(source => this.data.trafficSources[source] || 0)
      const dealData = categories.map(source => this.data.dealSources[source] || 0)

      const option = {
        tooltip: {
          trigger: 'axis',
          axisPointer: {
            type: 'shadow'
          }
        },
        legend: {
          data: ['流量', '成交'],
          top: 10
        },
        grid: {
          left: '3%',
          right: '4%',
          bottom: '3%',
          containLabel: true
        },
        xAxis: {
          type: 'category',
          data: categories,
          axisLabel: {
            interval: 0,
            rotate: 0
          }
        },
        yAxis: {
          type: 'value'
        },
        series: [
          {
            name: '流量',
            type: 'bar',
            data: trafficData,
            label: {
              show: true,
              position: 'top'
            },
            itemStyle: {
              color: '#409EFF'
            },
            barWidth: '30%'
          },
          {
            name: '成交',
            type: 'bar',
            data: dealData,
            label: {
              show: true,
              position: 'top'
            },
            itemStyle: {
              color: '#67C23A'
            },
            barWidth: '30%'
          }
        ]
      }

      this.chart.setOption(option)
    },
    handleResize () {
      if (this.chart) {
        this.chart.resize()
      }
    }
  }
}
</script>

<style scoped>
.text-blue { color: #409EFF; }
.clearfix {
  position: relative;
}
.expand-icon {
  position: absolute;
  right: 10px;
  top: 50%;
  transform: translateY(-50%);
  cursor: pointer;
  font-size: 16px;
  color: #909399;
  transition: all 0.3s;
}
.expand-icon:hover {
  color: #409EFF;
}
.chart-container {
  padding: 10px 0;
}
</style>
